/* ULTIMAX theme — vanilla JS, no dependencies */
(function () {
  "use strict";

  /* ---------- Mobile nav ---------- */
  function initMobileNav() {
    var toggle = document.querySelector("[data-nav-toggle]");
    var nav = document.querySelector("[data-mobile-nav]");
    if (!toggle || !nav) return;
    var close = nav.querySelector("[data-nav-close]");
    function open(state) {
      nav.setAttribute("data-open", state);
      document.body.style.overflow = state ? "hidden" : "";
      toggle.setAttribute("aria-expanded", state);
    }
    toggle.addEventListener("click", function () { open(true); });
    if (close) close.addEventListener("click", function () { open(false); });
    nav.addEventListener("click", function (e) { if (e.target.tagName === "A") open(false); });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") open(false); });
  }

  /* ---------- Carousel arrows ---------- */
  function initCarousels() {
    document.querySelectorAll("[data-carousel]").forEach(function (wrap) {
      var track = wrap.querySelector(".carousel");
      var prev = wrap.querySelector("[data-carousel-prev]");
      var next = wrap.querySelector("[data-carousel-next]");
      if (!track) return;
      function step() { return Math.min(track.clientWidth * 0.8, 640); }
      if (prev) prev.addEventListener("click", function () { track.scrollBy({ left: -step(), behavior: "smooth" }); });
      if (next) next.addEventListener("click", function () { track.scrollBy({ left: step(), behavior: "smooth" }); });
    });
  }

  /* ---------- Hero slider ---------- */
  function initHero() {
    document.querySelectorAll("[data-hero]").forEach(function (hero) {
      var slidesEl = hero.querySelector(".hero__slides");
      var dots = hero.querySelectorAll(".hero__dot");
      var slides = hero.querySelectorAll(".hero__slide");
      if (!slidesEl || slides.length < 2) return;
      var index = 0;
      var autoplay = hero.getAttribute("data-autoplay") === "true";
      var interval = parseInt(hero.getAttribute("data-interval"), 10) || 6000;
      var timer;
      function go(i) {
        index = (i + slides.length) % slides.length;
        slidesEl.scrollTo({ left: slides[index].offsetLeft, behavior: "smooth" });
        dots.forEach(function (d, di) { d.setAttribute("aria-current", di === index); });
      }
      dots.forEach(function (d, di) { d.addEventListener("click", function () { go(di); restart(); }); });
      function restart() { if (!autoplay) return; clearInterval(timer); timer = setInterval(function () { go(index + 1); }, interval); }
      var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      if (autoplay && !reduce) restart();
      hero.addEventListener("mouseenter", function () { clearInterval(timer); });
      hero.addEventListener("mouseleave", restart);
    });
  }

  /* ---------- Accordions ---------- */
  function initAccordions() {
    document.querySelectorAll(".accordion").forEach(function (acc) {
      var head = acc.querySelector(".accordion__head");
      if (!head) return;
      head.addEventListener("click", function () {
        var open = acc.getAttribute("open-state") === "true";
        acc.setAttribute("open-state", String(!open));
        head.setAttribute("aria-expanded", String(!open));
      });
    });
  }

  /* ---------- Product page: variants + gallery + qty ---------- */
  function initProduct() {
    var form = document.querySelector("[data-product-form]");
    if (!form) return;
    var dataEl = document.getElementById("product-json");
    var product = dataEl ? JSON.parse(dataEl.textContent) : null;
    var selects = form.querySelectorAll("[data-option-index]");
    var idInput = form.querySelector("[name='id']");
    var priceEls = document.querySelectorAll("[data-product-price]");
    var addBtn = form.querySelector("[data-add-btn]");
    var stickyAdd = document.querySelector("[data-sticky-add]");

    function currentOptions() {
      return Array.prototype.map.call(selects, function (s) { return s.value; });
    }
    function findVariant() {
      if (!product) return null;
      var opts = currentOptions();
      return product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }
    function formatMoney(cents) {
      return "$" + (cents / 100).toFixed(2);
    }
    function update() {
      var v = findVariant();
      if (!v) return;
      if (idInput) idInput.value = v.id;
      priceEls.forEach(function (priceEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          priceEl.innerHTML = "<s>" + formatMoney(v.compare_at_price) + "</s> <span class='on-sale'>" + formatMoney(v.price) + "</span>";
        } else {
          priceEl.textContent = formatMoney(v.price);
        }
      });
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? addBtn.getAttribute("data-add-label") : addBtn.getAttribute("data-sold-label");
      }
      if (stickyAdd) { stickyAdd.disabled = !v.available; }
    }
    selects.forEach(function (s) { s.addEventListener("change", update); });
    if (product) update();

    // gallery thumbs
    var main = document.querySelector("[data-gallery-main] img");
    document.querySelectorAll("[data-thumb]").forEach(function (t) {
      t.addEventListener("click", function () {
        if (main) { main.src = t.getAttribute("data-src"); main.srcset = ""; }
        document.querySelectorAll("[data-thumb]").forEach(function (o) { o.setAttribute("aria-current", "false"); });
        t.setAttribute("aria-current", "true");
      });
    });

    // qty
    document.querySelectorAll("[data-qty]").forEach(function (q) {
      var input = q.querySelector("input");
      q.querySelector("[data-qty-minus]").addEventListener("click", function () {
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      });
      q.querySelector("[data-qty-plus]").addEventListener("click", function () {
        input.value = (parseInt(input.value, 10) || 1) + 1;
      });
    });
  }

  /* ---------- Reveal on scroll ---------- */
  function initReveal() {
    var els = document.querySelectorAll("[data-reveal]");
    if (!("IntersectionObserver" in window) || !els.length) {
      els.forEach(function (el) { el.classList.add("is-in"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add("is-in"); io.unobserve(entry.target); }
      });
    }, { threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Sticky add-to-cart bar ---------- */
  function initStickyAtc() {
    var bar = document.querySelector("[data-sticky-atc]");
    var anchor = document.querySelector("[data-atc-anchor]");
    var mainAdd = document.querySelector("[data-product-form] [data-add-btn]");
    var stickyAdd = document.querySelector("[data-sticky-add]");
    if (!bar || !anchor) return;
    if (stickyAdd && mainAdd) {
      stickyAdd.addEventListener("click", function () { mainAdd.click(); });
    }
    if (!("IntersectionObserver" in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        // show bar only once the main add-to-cart has scrolled ABOVE the viewport
        var belowFold = e.boundingClientRect.top < 0;
        bar.classList.toggle("is-visible", !e.isIntersecting && belowFold);
      });
    }, { threshold: 0 });
    io.observe(anchor);
  }

  /* ---------- Reviews: show more ---------- */
  function initReviews() {
    document.querySelectorAll("[data-review-more]").forEach(function (btn) {
      var list = document.querySelector("[data-reviews-list]");
      if (!list) return;
      var expanded = false;
      btn.addEventListener("click", function () {
        expanded = !expanded;
        list.querySelectorAll("[data-review].is-hidden, [data-review].was-hidden").forEach(function (c) {
          if (expanded) { c.classList.remove("is-hidden"); c.classList.add("was-hidden"); }
          else { c.classList.add("is-hidden"); }
        });
        btn.textContent = expanded ? btn.getAttribute("data-label-less") : btn.getAttribute("data-label-more");
      });
    });
  }

  /* ---------- Cart count via AJAX (progressive) ---------- */
  function initNewsletter() {
    // native Shopify contact form handles submission; nothing needed
  }

  document.addEventListener("DOMContentLoaded", function () {
    initMobileNav();
    initCarousels();
    initHero();
    initAccordions();
    initProduct();
    initStickyAtc();
    initReviews();
    initReveal();
    initNewsletter();
  });
})();
